export default __webpack_public_path__ + "static/media/dataLeakageRealcase-en.f52b0f03.jpg";